import * as api from '../../services/cash_rounding/api_cash_rounding';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import { call, put, select, delay } from 'redux-saga/effects';
import * as SagaCommon from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListCashRoundingSaga(feathersApp) {
	yield takeLatest('FETCH_LIST_CASH_ROUNDING', callFetchListCashRounding, feathersApp);
}

function* callFetchListCashRounding(feathersApp, action) {
	const { silent, filters } = action;
	yield SagaCommon.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: 'cash_rounding',
			params: {
				docTypeArr: [DocType.CURRENCY]
			}
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield SagaCommon.showErrorListTable(error);
	}
}

export function* saveCashRoundingSaga(feathersApp) {
	yield takeEvery("SAVE_CASH_ROUNDING", callSaveCashRounding, feathersApp);
}
function* callSaveCashRounding(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveCashRounding, feathersApp, params);
		yield SagaCommon.doneSaveRecord(result, 'Cash rounding was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});
		yield callFetchListCashRounding(feathersApp, { silent: true });

	} catch (e) {
		yield SagaCommon.showErrorSaveRecord(e);
	}
}

export function* deleteCashRoundingFromListSaga(feathersApp) {
	yield takeEvery('DELETE_CASH_ROUNDING_FROM_LIST', callDeleteCashRoundingFromList, feathersApp);
}

function* callDeleteCashRoundingFromList(feathersApp, action) {
	yield deleteCashRounding(feathersApp, action);
	yield callFetchListCashRounding(feathersApp, { silent: true });
}

function* deleteCashRounding(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteCashRounding, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.CASH_ROUNDING } });
			yield callFetchListCashRounding(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteCashRoundingSaga(feathersApp) {
	yield takeEvery('DELETE_CASH_ROUNDING', callDeleteCashRounding, feathersApp);
}

function* callDeleteCashRounding(feathersApp, action) {
	const result = yield deleteCashRounding(feathersApp, action);
	yield delay(2000);
	if (result) {
		browserHistory.push('/admin/cash_rounding');
	}
}

export function* fetchCashRoundingForEditSaga(feathersApp) {
	yield takeEvery('FETCH_CASH_ROUNDING_BY_ID', callFetchCashRoundingForEdit, feathersApp);
}

function* callFetchCashRoundingForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.CASH_ROUNDING;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchCashRoundingById, feathersApp, fetchParams);
			yield SagaCommon.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
